module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "dashboard_wrapper"
  }, [(_vm.noCity) ? _c('div', {
    staticClass: "ml-20",
    class: _vm.addButtonClass
  }, [_c('h4', [_vm._v("No cities available ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'addCity',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn gradientbt"
  }, [_vm._v("Add City")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row dashBoardboxs_wrp"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager'
    },
    attrs: {
      "to": {
        name: 'Primarytrip',
        params: {
          tripStatus: 'complete',
          cityIds: this.cityIds
        }
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/completed_trips_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.allTripDetails.complete ? _vm.allTripDetails.complete : '0') + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Completed Trips")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager'
    },
    attrs: {
      "to": {
        name: 'Primarytrip',
        params: {
          tripStatus: 'ongoing',
          cityIds: this.cityIds
        }
      }
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleLinkClick.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ongoing_trip_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.allTripDetails.ongoing ? _vm.allTripDetails.ongoing : '0'))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Ongoing Trips")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager'
    },
    attrs: {
      "to": {
        name: 'Primarytrip',
        params: {
          tripStatus: 'scheduled',
          cityIds: this.cityIds
        }
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/schedule_trip_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.allTripDetails.scheduled ? _vm.allTripDetails.scheduled : '0') + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Scheduled Trips")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager'
    },
    attrs: {
      "to": {
        name: 'surveys',
        params: {
          surveyStatus: 'scheduled',
          cityIds: this.cityIds
        }
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/schedule_surveys_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v("\n                                    " + _vm._s(_vm.allDashboardDetails.PendingAndUpcomingSurveyCount ?
    _vm.allDashboardDetails.PendingAndUpcomingSurveyCount : '0') + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Scheduled Surveys")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager'
    },
    attrs: {
      "to": {
        name: 'surveys',
        params: {
          surveyStatus: 'complete',
          cityIds: this.cityIds
        }
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/completed_surverys_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v("\n                                    " + _vm._s(_vm.allDashboardDetails.CompletedSurveyCount ?
    _vm.allDashboardDetails.CompletedSurveyCount : '0') + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Completed Surveys")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager' || _vm.adminCheck == 'superVisor'
    },
    attrs: {
      "to": {
        name: 'wasteCollectionArea',
        params: {
          cityIds: this.cityIds,
          status: 'Active'
        }
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/waste_collection_area_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v("\n                                    " + _vm._s(_vm.allDashboardDetails.WasteCollectionAreaCount ?
    _vm.allDashboardDetails.WasteCollectionAreaCount : '0') + "\n                                ")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Zones")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager' || _vm.adminCheck == 'superVisor'
    },
    attrs: {
      "to": {
        name: 'vehicles',
        params: {
          cityIds: this.cityIds,
          status: 'Active'
        }
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/vehicles_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.allDashboardDetails.VehicleCount ?
    _vm.allDashboardDetails.VehicleCount : '0'))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Vehices")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('router-link', {
    class: {
      'disabled-link': _vm.adminCheck == 'reportManager' || _vm.adminCheck == 'monitoringManager' || _vm.adminCheck == 'superVisor'
    },
    attrs: {
      "to": {
        name: 'helperAndDriver',
        params: {
          roleType: 'driver',
          cityIds: this.cityIds
        }
      }
    }
  }, [_c('div', {
    staticClass: "dashBoardboxs"
  }, [_c('span', {
    staticClass: "img_side"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/driver_img.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "content_side"
  }, [_c('h1', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.allDashboardDetails.DriverCount ?
    _vm.allDashboardDetails.DriverCount : '0'))]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("Drivers")])])])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "welcome_img"
  }, [_c('div', {
    staticClass: "welcome_img_flex"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "welcome_heading"
  }, [_c('h3', [_vm._v("Welcome to " + _vm._s(this.$store.state.auth.user.role.key == "superAdmin" ? "Admin" :
    this.$store.state.auth.user.cityId.cityName))]), _vm._v(" "), _c('p', [_vm._v("With Our Platform, You Can Create And Manage Houses, Surveys And Trips.")])])])])]), _vm._v(" "), (_vm.noCity) ? _c('div', [_c('div', [_vm._v("No cities available")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'surveysCreate',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('a', [_vm._v("Click here to add city")])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('img', {
    attrs: {
      "src": "/static/img/welcome_back_img.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ea669ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/dashboard/dashboard.vue
// module id = 2284
// module chunks = 1